import React from 'react';
import { Button } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { DASHBOARD_COLORS } from '../dashboardStyles';

/**
 * Opens AI chat for a dashboard insight. Stops click from bubbling to parent cards.
 */
const InsightAiAssistantButton = ({ onClick, size = 'small', sx }) => (
  <Button
    size={size}
    variant="outlined"
    startIcon={<AutoAwesomeIcon sx={{ fontSize: 16 }} />}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick?.(e);
    }}
    onMouseDown={(e) => e.stopPropagation()}
    sx={{
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.75rem',
      py: 0.25,
      px: 1,
      minHeight: 28,
      borderRadius: 999,
      borderColor: DASHBOARD_COLORS.accent,
      color: DASHBOARD_COLORS.accent,
      bgcolor: '#fff',
      flexShrink: 0,
      '&:hover': {
        borderColor: DASHBOARD_COLORS.accentHover,
        bgcolor: 'rgba(102, 126, 234, 0.06)',
      },
      ...sx,
    }}
  >
    AI Assistant
  </Button>
);

export default InsightAiAssistantButton;
